import React, { memo } from 'react';
import { Box, Skeleton } from '@ublend-npm/aulaui-core';
import {
  SPACE_CARD_DESCRIPTION_HEIGHT,
  SPACE_CARD_INNER_WIDTH,
  SPACE_CARD_PROGRESS_SECTION_GAP,
  SPACE_CARD_PROGRESS_SECTION_HEIGHT,
  SPACE_CARD_SKELETON_SURFACE,
  SPACE_ENGAGEMENT_LINK_HEIGHT,
  SPACE_PROGRESS_BAR_HEIGHT,
  SPACE_PROGRESS_LABEL_HEIGHT,
} from './spaceWidgetConstants';

type SpaceCardContentRefreshSkeletonProps = {
  isStudent: boolean;
  /** Which placeholder region to render inside the card text block. */
  variant?: 'description' | 'progress';
  skeletonSurface?: string;
};

const SpaceCardContentRefreshSkeleton = ({
  isStudent,
  variant = 'description',
  skeletonSurface = SPACE_CARD_SKELETON_SURFACE,
}: SpaceCardContentRefreshSkeletonProps) => {
  if (variant === 'description') {
    return (
      <Skeleton
        aria-hidden
        data-testid="space-card-content-refresh-skeleton"
        kind="rounded"
        height={SPACE_CARD_DESCRIPTION_HEIGHT}
        sx={{
          width: SPACE_CARD_INNER_WIDTH,
          borderRadius: '0.375rem',
          bgcolor: skeletonSurface,
        }}
      />
    );
  }

  if (isStudent) {
    return (
      <Box
        aria-hidden
        data-tour="home-space-card-progress"
        sx={{
          width: SPACE_CARD_INNER_WIDTH,
          height: SPACE_CARD_PROGRESS_SECTION_HEIGHT,
          display: 'flex',
          flexDirection: 'column',
          gap: SPACE_CARD_PROGRESS_SECTION_GAP,
          flexShrink: 0,
        }}
      >
        <Skeleton
          kind="rounded"
          height={SPACE_PROGRESS_BAR_HEIGHT}
          sx={{
            width: '100%',
            borderRadius: '999px',
            bgcolor: skeletonSurface,
          }}
        />
        <Skeleton
          kind="rounded"
          height={SPACE_PROGRESS_LABEL_HEIGHT}
          sx={{
            width: '42%',
            borderRadius: '0.375rem',
            bgcolor: skeletonSurface,
          }}
        />
      </Box>
    );
  }

  return (
    <Skeleton
      aria-hidden
      data-tour="home-space-card-engagement"
      kind="rounded"
      height={SPACE_ENGAGEMENT_LINK_HEIGHT}
      sx={{
        width: SPACE_CARD_INNER_WIDTH,
        borderRadius: '0.375rem',
        bgcolor: skeletonSurface,
        flexShrink: 0,
      }}
    />
  );
};

export default memo(SpaceCardContentRefreshSkeleton);
